module.exports = __webpack_public_path__ + "static/img/or_code.625e339.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/or_code.png
// module id = sEA0
// module chunks = 18